<script>
	import { creds } from "./stores";
	import { onMount } from "svelte";
	import { resultsMap } from "./lib";
	import { LottiePlayer } from "@lottiefiles/svelte-lottie-player";
	export let image;
	export let background;

	import { createEventDispatcher } from "svelte";
	const dispatch = createEventDispatcher();

	var captureImage = function () {
		var canvas = document.createElement("canvas");
		// canvas.width = 480;
		// canvas.height = 640;
		canvas.width = image.width;
		canvas.height = image.height;
		canvas.ctx = canvas.getContext("2d");
		canvas.ctx.drawImage(image, 0, 0);

		let blob = canvas.toDataURL("image/png", 0.9);
		let size = blob.length;
		while (size > 1.5 * 1000 * 1000) {
			const diff =
				Math.sqrt(Math.min(1, 1 / (size / 1000 / 1000))) - 0.07;
			canvas.width = canvas.width * diff;
			canvas.height = canvas.height * diff;
			canvas.ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
			blob = canvas.toDataURL("image/png", 0.9);
			size = blob.length;
			console.log(size);
		}
		console.log(blob);
		return blob;
	};

	let dataURL,
		result = "";
	$: if (image) dataURL = captureImage();
	$: if (dataURL) send(dataURL);

	// const DEVELOP = "1";
	const DEVELOP = "0";

	const delay = (t) => new Promise((resolve) => setTimeout(resolve, t));
	async function send(url) {
		await delay(400);
		// console.log(url)
		// var response = await fetch("/client_id");
		// if(!response.ok) return result = {status: -1, result: 'Error ' + response.status};
		// let client_id = await response.text();
		// if(!client_id) return result = 'Error ' + response.status;

		// response = await fetch("/tokens");
		// if(!response.ok) return result = {status: -1, result: 'Error ' + response.status};
		// let tokens = await response.json();
		// if(!tokens) return result = 'Error ' + response.status;

		const pass =
			$creds.id.length > 11
				? { pinfl: $creds.id }
				: { pass_data: $creds.id };

		const req = {
			birth_date: $creds.date,
			photo_from_camera: {
				front: url,
			},
			client_id: "dev_tester-kYJmOs5F6IGSk9GnXHSfaN6rSPKaxPvz1dyyQqvG",
			device: "Web-Tester",
			agreed_on_terms: true,
			threshold: 0.5,
			...pass,
		};

		var response = await fetch(
			(DEVELOP == "1" ? "http://localhost:3000" : "") + "/liveness",
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					// Authorization: `${tokens.token_type} ${tokens.access_token}`,
				},
				redirect: "follow",
				body: JSON.stringify(req),
			}
		);
		if (!response.ok)
			return (result = {
				status: -1,
				result: "Error " + response.status,
			});
		let job_id = (await response.json()).job_id;
		if (!job_id) return (result = "Error " + response.status);

		await delay(1000);

		async function checkLoop() {
			response = await fetch(
				(DEVELOP == "1" ? "http://localhost:3000" : "") + "/status",
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						// Authorization: `${tokens.token_type} ${tokens.access_token}`,
					},
					redirect: "follow",
					body: JSON.stringify({
						job_id: job_id,
					}),
				}
			);
			if (response.status == 200) {
				let res = await response.json();
				result = {
					status: 1,
					result: res.first_name + " " + res.last_name,
				};
				clearTimeout(checkLoop.loop);
				return;
			} else if (response.status != 202) {
				let res = await response.text();
				try {
					let o = JSON.parse(res);
					result = {
						status: o.result_code,
						result: resultsMap[o.result_code] || o.result_note,
					};
				} catch (e) {
					result = {
						status: -1,
						result: res,
					};
				}
				clearTimeout(checkLoop.loop);
				return;
			}
			checkLoop.loop = setTimeout(checkLoop, 2000);
		}
		checkLoop.loop = setTimeout(checkLoop, 1200);
	}
	let root;
	onMount(() => {
		root.insertBefore(background, root.children[0]);
	});
</script>

<div
	class="LivenessModule"
	data-icon={result ? "" : "loading"}
	bind:this={root}
>
	{#if result}
		<h1>{result.result}</h1>
		{#if result.status != 1}
			<LottiePlayer
				src="anim/fail.json"
				autoplay={true}
				loop={true}
				controls={false}
				renderer="svg"
				background="transparent"
			/>
		{:else}
			<LottiePlayer
				src="anim/success.json"
				autoplay={true}
				loop={false}
				controls={false}
				renderer="svg"
				background="transparent"
			/>
		{/if}
		<button
			class="button"
			on:click={() => dispatch("reset")}
			data-icon="keyboard_arrow_left">Try again</button
		>
		<img src="./img/logo-white.webp" alt="MyID" />
	{:else}
		<h1>Liveness check</h1>
		<LottiePlayer
			src="anim/circle.json"
			autoplay={true}
			controls={false}
			loop={true}
			renderer="svg"
			background="transparent"
		/>
		<img src="./img/logo-white.webp" alt="MyID" />
	{/if}
</div>

<style>
	.LivenessModule {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		color: white;
		font-size: 1.4em;
		background: rgba(0, 0, 0, 0.3);
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
		padding: 1em;
		padding-bottom: 2em;
		box-sizing: border-box;
	}
	.LivenessModule > :global(*) {
		position: relative;
		z-index: 1;
	}
	.LivenessModule :global(svg) {
		max-width: 20em;
		max-height: 20em;
		margin-bottom: 2em;
	}
	.button {
		background: #d625ae44;
		border: none;
		border-radius: 4px;
		color: white;
		padding: 0.7em 1.5em;
		min-width: 10em;
		cursor: pointer;
		margin-bottom: 3em;
	}

	.LivenessModule :global(canvas) {
		display: block;
		/*transform: scaleX(-1);*/
		height: 100%;
		left: 50%;
		transform: translateX(-50%);
		position: relative;
		position: absolute;
		top: 0;
		pointer-events: none;
		z-index: 0;
		opacity: 0;
		animation: fade-in 1s normal forwards ease;
	}
	@keyframes fade-in {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
	img {
		max-width: 10em;
	}
</style>
